import React, { Fragment } from "react";

const NonHostedLinks = (props) => {
    const cid = props.cid;
    const sid = props.sid;
    const jobLocation = props.jobLocation;
    const jobSearch = props.jobSearch;
    const seSt = props.seSt;
    const seJk = props.seJk;

    function clickConfirmResumeSubmit(){
        window.location = props.redirectBaseUrl+'/results/?job='+jobSearch+'&location='+jobLocation+'&OID=3726&CID='+cid+'&SID='+sid+'&seJk='+seJk+'&sePr=SPONSOR&fbn=true&jobEx=true&seSt='+seSt;
        
    }

    var continueAfterFormSubmit = function(){
		window.location = props.redirectBaseUrl+"/results/?job_title="+props.jobTitle+"&job="+props.jobSearch+"&location="+jobLocation+"&OID=3726&job_category=&seSt="+seSt+"&seJk="+seJk;
    }


    return (
        <Fragment>
            <div className="nonHostedLinks">
                <a href="#" onClick={() => clickConfirmResumeSubmit()} style={{paddingRight:'35px'}} >View job details</a>
                <a href="#" onClick={() => continueAfterFormSubmit()} >More jobs like this</a>
            </div>
        </Fragment>
    )

}

export default NonHostedLinks;